import { useQuery } from "@tanstack/react-query";
import { QUERY_KEYS } from "../queryKeys";
import { getSearchProducts } from "@/services/api/productApis";

export const useGetSearchProducts = (searchTerm: string) => {
  return useQuery({
    queryKey: [QUERY_KEYS.GETSEARCHPRODUCTS, searchTerm],
    queryFn: async () => getSearchProducts(searchTerm),
    enabled: !!searchTerm,
  });
}